import React from 'react'
import Plugin from 'core/plugins/plugin'

const developerPlugin = new Plugin('developer', 'Developer', '/ui/developer')

export default developerPlugin
